import React, { useState } from 'react';
import LeadsKanbanPage from './LeadsKanbanPage';
import LeadViewDrawer from './LeadViewDrawer';
import LeadFormDrawer from './LeadFormDrawer';

const PipelinePage: React.FC = () => {
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
  const [formDrawerOpen, setFormDrawerOpen] = useState(false);
  const [editLeadId, setEditLeadId] = useState<string | null>(null);

  return (
    <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <LeadsKanbanPage onLeadClick={(id) => setSelectedLeadId(id)} />
      <LeadViewDrawer
        open={selectedLeadId != null}
        onClose={() => setSelectedLeadId(null)}
        leadId={selectedLeadId}
        onEdit={(id) => {
          setEditLeadId(id);
          setFormDrawerOpen(true);
          setSelectedLeadId(null);
        }}
      />
      <LeadFormDrawer
        open={formDrawerOpen}
        onClose={() => {
          setFormDrawerOpen(false);
          setEditLeadId(null);
        }}
        onSuccess={() => setFormDrawerOpen(false)}
        editLeadId={editLeadId}
      />
    </div>
  );
};

export default PipelinePage;
